import React from 'react';

const researchItems = [
  {
    title: 'DeFi Ecosystem Trends Q1 2025',
    description: 'A deep dive into the performance and innovations across decentralized finance protocols.',
    tag: 'DeFi',
    date: 'May 1, 2025',
  },
  {
    title: 'Crypto Market Liquidity Analysis',
    description: 'Insights on liquidity shifts across major tokens, and what they mean for investors.',
    tag: 'Markets',
    date: 'April 24, 2025',
  },
  {
    title: 'Cross-Chain Technology Advances',
    description: 'Evaluating the latest breakthroughs in bridging protocols and chain interoperability.',
    tag: 'Blockchain',
    date: 'April 10, 2025',
  },
  {
    title: 'Security Risks in Centralized Exchanges',
    description: 'Best practices and key vulnerabilities affecting modern CEX platforms.',
    tag: 'Security',
    date: 'March 28, 2025',
  },
  {
    title: 'How Laani is Scaling Blockchain Access',
    description: 'An internal look into Laani’s infrastructure and our approach to mass adoption.',
    tag: 'Laani Research',
    date: 'March 15, 2025',
  },
];

const ResearchPage = () => {
  return (
    <div className="min-h-screen px-4 sm:px-8 py-16 text-gray-100 bg-transparent">
      <div className="max-w-7xl mx-auto">
        <header className="mb-16 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4 text-white">Research & Insights</h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Discover our latest research on crypto markets, decentralized technologies, and the future of digital finance.
          </p>
        </header>

        <section className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {researchItems.map((item, index) => (
            <div
              key={index}
              className="bg-gray-900 border border-gray-700 p-6 rounded-2xl hover:shadow-lg hover:border-indigo-500 transition duration-300 flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm text-indigo-400 font-medium">{item.tag}</span>
                  <span className="text-sm text-gray-500">{item.date}</span>
                </div>
                <h2 className="text-xl font-semibold text-white mb-2">{item.title}</h2>
                <p className="text-gray-400 text-sm">{item.description}</p>
              </div>
              <div className="mt-4">
                <button className="text-indigo-400 hover:text-indigo-300 text-sm font-medium">
                  Read more →
                </button>
              </div>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default ResearchPage;

